






































import { Component, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import EventLogMethods from '@/mixins/EventLogMethods.vue';
import EventLogItem from '@/components/Admin/Lists/EventLogItem.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import { dateFormat } from '@/ts/DefaultTableConfigs';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        EventLogItem,
        FlexibleTable,
    },
})
export default class EventLogs extends Mixins(EventLogMethods) {
    public tableEntity: string = 'EventLogsList';

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', sortable: true, required: true, html: true, filter: false,
                field: (row: any) => !row.seen.length ? `<b><span class="unseen-ticket-dot"></span>${row.id}</b>` : row.id,
            },
            { name: 'type', label: this.$t('general.type', 'Type'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => this.getEventLogTitle(row.message, 'title'),
            },
            { name: 'description', label: this.$t('general.description', 'Description'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => this.getEventLogDescription(row.message),
            },
            { name: 'date', label: this.$t('general.date', 'Date'), align: 'left', field: 'created_at', sortable: true, required: false, filterType: 'date', dateFormat },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'type',
                'description',
                'date',
            ],
        };
    }

    get eventLogs(): any {
        return this.$store.getters['EventLogs/getEventLogs'];
    }

    public handleRowClick(eventLogId: number) {
        const log = this.eventLogs.find((eventLog: any) => eventLog.id === eventLogId);

        this.previewEventLog(log.id, log.message, log.seen.length);
    }

    public markAllLogsAsSeen() {
        this.$store.dispatch(Actions.MARK_ALL_EVENT_LOGS_AS_SEEN);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_EVENT_LOGS, { withExceptions: true });
    }

}
